import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import MakeHash from 'make-hash';
import Button from 'components/button/button';
import Badge from 'components/badge';
import ButtonIcon from 'components/button/button-icon';
import Icon from 'components/icons/icon';
import Text from 'components/text/text';
import TextField from 'components/fields/text-field';
import SelectField from 'components/fields/select-field';
import RadioGroup from 'components/fields/radios/radio-group';
import messages from './messages';

class EditForm extends React.Component {
  constructor(){
    super();

    this.state = {
      'isEditing': false
    };

    this.fields = [];

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.onEditClick = this.handleEditClick.bind(this);
    this.onCancelClick = this.handleCancelClick.bind(this);
    this.onDeleteClick = this.handleDeleteClick.bind(this);
    this.onSubmit = this.handleSubmit.bind(this);
  }

  trackField(field) {
    if (!field || this.fields.length === this.props.fields.length) {
      return;
    }
    this.fields.push(field);
  }

  handleEditClick(event) {
    this.toggleEditMode();
  }

  handleCancelClick(event) {
    this.toggleEditMode();
  }

  /**
   * TODO: Start PUT request to profiles
   */
  handleDeleteClick(event) {
    this.toggleEditMode();
  }

  handleSubmit(event) {
    const isValid = !this.formHasErrors();

    if (event) event.preventDefault();

    if (isValid) {
      this.save();
    }
  }

  formHasErrors() {
    let errors = this.fields.filter(field => {
      const hasError = field.state.isError || field.input.value.trim().length === 0;

      if (hasError) {
        field.setState({ 'isError': true });
      }

      return hasError;
    });

    return errors.length > 0;
  }

  toggleEditMode() {
    this.setState({
      'isEditing': !this.state.isEditing
    });
  }

  save() {
    this.toggleEditMode();
    this.props.onSave(this.fields);
  }

  _renderSwapAreas() {
    return this.props.fields.map((field, i) => {
      const staticValue = field.type === 'password' ? '********' : field.value;
      let editArea;

      if (field.type === 'radio') {
        editArea = (
          <div className="set">
            <div className="set-hd">
              <Text
                className="mix-txt_uppercase"
                color="DefaultGray"
                weight="light"
              >
                {field.label}
              </Text>
            </div>
            <div className="set-bd">
              <RadioGroup options={field.options} className="radioGroup_2" id={field.id} name={field.name} />
            </div>
          </div>
        )
      } else if (field.type === 'select') {
        editArea = (
          <SelectField
            label={field.label}
            options={field.options}
            id={field.id}
            name={field.name}
          />
        )
      } else {
        editArea = (
          <TextField
            type={field.type}
            id={field.id}
            name={field.name}
            label={field.label}
            errorMsg={field.error}
            updateValue={() => {}}
            ref={(field) => { this.trackField(field) }}
          />
        )
      }

      return (
        <fieldset className="form-swapArea" key={MakeHash(`${field.label}-${i}`)}>
          <div className="form-swapArea-static">
            <div className="set">
              <div className="set-hd">
                <Text
                  className="mix-txt_uppercase"
                  color="DefaultGray"
                  weight="light"
                >
                  {field.label}
                </Text>
              </div>
              <div className="set-bd">
                <Text
                  className="txt_lgPlus"
                  color="Lightest"
                  type="mdLg"
                  weight="light"
                >
                  {staticValue}
                </Text>
              </div>
            </div>
          </div>
          <div className="form-swapArea-edit">
            {editArea}
          </div>
        </fieldset>
      )
    });
  }

  _renderFormIcon() {
    const iconColor = this.state.isEditing ? 'DefaultBlue': 'DarkGray';

    if (this.state.isEditing && this.props.isDeletable) {
      return (
        <button
          className="form-icon form-icon_delete"
          type="button"
          onClick={this.onDeleteClick}
        >
          <Badge
            badgeColor="DefaultOrange"
            icon="trash"
            size="lg"
            fillColor="DefaultOrange"
            strokeColor="DefaultOrange"
          />
        </button>
      );
    } else {
      return (
        <div className="form-icon">
          <Badge
            badgeColor={iconColor}
            icon={this.props.iconType}
            size={this.props.iconSize}
            fillColor={iconColor}
            strokeColor={iconColor}
          />
        </div>
      );
    }
  }

  render() {
    const { intl } = this.props;
    const swapAreas = this._renderSwapAreas();
    const formIcon = this._renderFormIcon();
    const formClasses = classNames(
      'form form_boxed',
      { 'form_editing': this.state.isEditing }
    );

    return (
      <form
        onSubmit={this.onSubmit}
        className={formClasses}
        autoComplete="off"
        noValidate
        ref={(el => { this.form = el; })}
      >
        <div className="form-editTrigger">
          <ButtonIcon
            description="Edit Form"
            iconType="pencil"
            iconSize="md"
            type="button"
            onClick={this.onEditClick}
          />
        </div>
        {formIcon}
        {swapAreas}
        <div className="form-ctaArea">
          <Button
            animateOnClick
            className="btn_fixedWidthMd"
            theme="dark"
            onClick={this.onSubmit}
          >
            {intl.formatMessage(messages.edit_form_save_label)}
          </Button>
          <Button
            className="mix-btn_borderless mix-btn_padSm mix-btn_mobile mix-btn_alignTop"
            onClick={this.onCancelClick}
          >
            {intl.formatMessage(messages.edit_form_cancel_label)}
          </Button>
        </div>
      </form>
    );
  }
}

EditForm.propTypes = {
  'fields': PropTypes.array.isRequired,
  'iconSize': PropTypes.string,
  'iconType': PropTypes.string,
  'isDeletable': PropTypes.bool,
  'onSave': PropTypes.func.isRequired
}

export default injectIntl(EditForm);



// WEBPACK FOOTER //
// ./src/client/components/forms/edit-form.jsx